export class EmployeesListModel {
    uid: number;
    guid?: string;
    name: string;
    dni: string;
    phone: number;
    email: string;
    birth_date: Date;
    address: string;
    city: string;
    province: string;
    country: string;
    postal_code: number;
    irpf: number;
    workday: number;
    marital_status: number;
    children: number;
    property_type: number;
    category: string;
    contract_type: number;
    bank_account: string;
    vacationDaysPerYear: number;
    vacationDaysPreviousYears: number;
    active: boolean;
    accountingmodels_id: number;
    accountingmodels_number: string;
    password: string;
    datosAccesoConfigurados: boolean;
    bicAccountUid: string;
    employeesActivities: Array<EmployeesActivitiesModel>;

    // Geolocalización
    activarGeolocalizacion: boolean;
    geolocalizacionAceptada: boolean;
    geolocalizacionAceptadaFecha: Date | null;

    // Registro de horas
    tieneRegistroHorasAbierto: boolean;
    duracionRegistroHorasAbierto: string;

    // Reservas PRO
    displayName: string | null;
    calendarColor: string | null;
    bookingStatus: string | null;

    constructor() {
        this.email = "";
        this.address = "";
        this.city = "";
        this.province = "";
        this.country = "";
        this.bank_account = "";
        this.category = "";
        this.vacationDaysPerYear = 0;
        this.vacationDaysPreviousYears = 0;
        // Un empleado nuevo debe quedar activo por defecto: si se deja sin tocar el toggle
        // "Activo" del formulario, se crea con active=false y desaparece de /employees/list,
        // que por defecto oculta los inactivos (hideInactive=true en EmployeeListComponent).
        this.active = true;

        this.employeesActivities = new Array<EmployeesActivitiesModel>();

        // Inicialización de geolocalización
        this.activarGeolocalizacion = false;
        this.geolocalizacionAceptada = false;
        this.geolocalizacionAceptadaFecha = null;

        // Inicialización de Reservas PRO
        this.displayName = null;
        this.calendarColor = null;
        this.bookingStatus = null;
    }
}

export class EmployeesActivitiesModel {
    employeesId: number;
    activitiesId: number;
    activityName: string;
    percentage: number;
}
